/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const StructClaimValue: core.serialization.ObjectSchema<
    serializers.StructClaimValue.Raw,
    Truvity.StructClaimValue
> = core.serialization.object({
    value: core.serialization.lazy(() => serializers.CredentialClaimValues),
});

export declare namespace StructClaimValue {
    export interface Raw {
        value: serializers.CredentialClaimValues.Raw;
    }
}
